<template>
  <div class="t-lk-leads">
    <div class="t-lk-container">
      <h1 class="t-lk-title t-lk-title-link__title t-lk-container-mobile">
        {{ $root.staticText.lk.leadsTitle }}
      </h1>
      <div v-if="leadExpiredCount >= 3" v-animation:bottom.delay class="t-lk-leads__container">
        <div class="t-lk-leads__item">
          <div>
            Нарушены
            <a
              class="t-lk-leads__link"
              target="_blank"
              href="/pages/usloviya_ispol_zovaniya_materialov_razmeshchennykh_na_web_sayte_kompanii_axoft"
              ><b>условия использования сервиса</b></a
            >. Доступ к системе передачи лидов заблокирован. Если вы считаете, что это произошло по ошибке, напишите на
            <a class="t-lk-leads__link" href="mailto:aosupport@axoftglobal.ru"><b>aosupport@axoftglobal.ru</b></a> или обратитесь к
            своему персональному менеджеру.
          </div>
        </div>
      </div>
      <div
        v-animation:bottom.delay
        class="t-lk-leads__header"
        :class="{
          't-lk-leads__header--not-confirmed': isFirst,
        }"
      >
        <template v-if="isFirst">
          <div class="t-lk-leads__item">
            <div class="t-lk-leads__content">
              <h4 class="t-lk-leads__subtitle">{{ $root.staticText.lk.leadsFirstTitle }}</h4>
              <div class="t-lk-leads__text">
                {{ $root.staticText.lk.leadsFirstText }}
                <a v-if="linkOffer" v-link :href="linkOffer" class="t-lk-leads__link">
                  {{ $root.staticText.lk.leadsFirstText2 }}
                </a>
                <template v-if="linkTerms">
                  {{ $root.staticText.lk.leadsFirstText3 }}
                  <a :href="linkTerms" v-link class="t-lk-leads__link">
                    {{ $root.staticText.lk.leadsFirstText4 }}
                  </a>
                </template>
                <br />
                {{ $root.staticText.lk.leadsFirstText5 }}
              </div>
              <div class="t-btn _lk _border-gray" @click="reuqestLeadsSecondStep">
                {{ $root.staticText.lk.leadsFirstBtn }}
              </div>
            </div>
            <!-- <div class="t-lk-leads__btn t-btn _lk _border-gray" @click="reuqestLeadsSecondStep">
                            {{ $root.staticText.lk.leadsFirstBtn }}
                        </div> -->
            <div class="t-lk-leads__img">
              <img src="/dist/img/lead.png" alt="lead" />
            </div>
          </div>
          <div class="t-lk-leads__item _green _order">
            <h4 class="t-lk-leads__subtitle">{{ $root.staticText.lk.leadsFirstRightTitle }}</h4>
            <div class="t-lk-leads__text">
              {{ $root.staticText.lk.leadsFirstRightText }}
            </div>
            <a v-link href="/lk/competencies" class="t-lk-leads__btn t-btn _lk _border">
              {{ $root.staticText.lk.leadsTwoBtn }}
            </a>
          </div>
        </template>

        <template v-else>
          <div class="t-lk-leads__item" :class="{ _green: rating > 4, _blue: rating <= 4 }">
            <h4 class="t-lk-leads__subtitle _big">
              {{ $root.staticText.lk.leadsRating }}
            </h4>
            <div class="t-lk-leads__user-params">
              <span class="t-lk-leads__rating">{{ rating }}</span>
              <span class="t-lk-leads__lead-expired">
                <b>{{ leadExpiredCount }}</b>
                просроченных лидов
              </span>
            </div>
            <div class="t-lk-leads__text">
              {{ rating > 4 ? $root.staticText.lk.leadsRatingText : $root.staticText.lk.leadsRatingText2 }}
            </div>
            <router-link v-if="rating > 4" :to="{ name: 'lk-rating-history' }" class="t-lk-leads__rating-link">
              {{ $root.staticText.lk.ratingHistoryBtn }}
            </router-link>
            <router-link v-else-if="rating <= 4 && linkFaqBack" :to="linkFaqBack" class="t-lk-leads__rating-link">
              {{ $root.staticText.lk.leadsRatingBtn2 }}
            </router-link>
          </div>
          <div class="t-lk-leads__item">
            <h4 class="t-lk-leads__subtitle">{{ $root.staticText.lk.leadsThird }}</h4>
            <div class="t-lk-leads__text">
              {{ $root.staticText.lk.leadsThirdText }}
            </div>
            <button @click="showHowWorkWithLeadsModal" class="t-lk-leads__btn t-btn _lk _border-gray">
              {{ $root.staticText.lk.leadsThird2 }}
            </button>
          </div>

          <div class="t-lk-leads__item">
            <h4 class="t-lk-leads__subtitle">{{ $root.staticText.lk.leadsThird3 }}</h4>
            <div class="t-lk-leads__text">
              {{ $root.staticText.lk.leadsThirdText3 }}
            </div>

            <div class="t-lk-leads__button-group">
              <router-link class="t-lk-leads__btn t-btn _lk _border-gray" to="/lk/competencies" target="_blank">
                {{ $root.staticText.lk.compBtn3 }}
              </router-link>
              <router-link class="t-lk-leads__btn t-btn _lk _border-gray" v-if="linkFaqMore" :to="linkFaqMore" target="_blank">
                {{ $root.staticText.lk.compBtn2 }}
              </router-link>
            </div>
            <div class="t-lk-leads__img">
              <img src="/dist/img/circle.png" alt="lead" />
            </div>
          </div>
        </template>
      </div>

      <LeadTransferRulesNotice v-animation:bottom.delay class="t-lk-leads__lead-transfer-rules-notice"></LeadTransferRulesNotice>

      <banner-native-cmp v-if="banner" v-animation:bottom.delay :banner="banner" />

      <template v-if="leads.length">
        <div class="t-lk-leads__leads-list-header">
          <h2 v-animation:bottom.delay class="t-lk-title t-lk-title-link__title t-lk-container-mobile">
            <!-- {{ $root.staticText.lk.leadsNew }} -->
            Лиды
          </h2>

          <div class="t-events-buttons">
            <div class="t-events-buttons__item" :class="{ _active: leadsView === 'list' }" @click="leadsView = 'list'">
              <lk-list-icon class="t-events-buttons__svg" />
              <div class="t-events-buttons__text">Список</div>
            </div>
            <div class="t-events-buttons__item _stroke" :class="{ _active: leadsView === 'tile' }" @click="leadsView = 'tile'">
              <lk-tile-icon class="t-events-buttons__svg" />
              <div class="t-events-buttons__text">Плитка</div>
            </div>
          </div>
        </div>

        <lk-leads-list-cmp :filter="leadsFilter" :leadsView="leadsView" :leads="leads" :reasons="reasons" />
      </template>

      <h2
        v-if="
          (leadsCompleted.length > 0 && leadsCompleted != 'empty' && Object.keys(this.$route.query).length == 0) ||
            Object.keys(this.$route.query).length > 0
        "
        v-animation:bottom.delay
        class="t-lk-title t-lk-container-mobile"
      >
        {{ $root.staticText.lk.leadsCompletedTitle }}
      </h2>

      <div
        v-if="
          (leadsCompleted.length > 0 && leadsCompleted != 'empty' && Object.keys(this.$route.query).length == 0) ||
            Object.keys(this.$route.query).length > 0
        "
        v-animation:bottom.delay
        class="t-lk-promotions-completed t-lk-leads__wrap"
      >
        <div v-animation:bottom.delay class="t-lk-promotions-completed__row">
          <lk-search-cmp :obj-undefined="{ currentPage: undefined }"> </lk-search-cmp>
          <filter-cmp
            v-if="filter"
            class="t-lk-promotions-completed__filter"
            :filter="filter"
            :obj-undefined="{ currentPage: undefined }"
            :name-btn="$root.staticText.lk.leadsFilterBtn"
            is-date
            allow-range-date
            allow-single-date
          >
          </filter-cmp>
        </div>
        <div class="t-lk-promotions-completed-table">
          <div v-animation:bottom.delay class="t-lk-promotions-completed-table__row _first">
            <div
              class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td"
              v-for="(item, index) in leadsCompletedTitle"
              :key="'leadsCompletedTitle' + index"
            >
              {{ item }}
            </div>
          </div>
          <div class="js-completed-leads">
            <div v-animation:bottom.delay v-for="item in leadsCompleted" class="t-lk-promotions-completed-table__row">
              <div class="t-lk-promotions-completed-table__td">
                <router-link v-if="item.link" :to="item.link" class="t-lk-leads-table__name t-link-hover">
                  {{ item.name }}
                </router-link>
                <div v-else class="t-lk-leads-table__name">{{ item.name }}</div>
                <div class="t-lk-leads-table__desc">{{ item.description }}</div>
              </div>
              <div class="t-lk-promotions-completed-table__td t-lk-leads-table__top">
                <div class="t-lk-promotions-completed-table__date">{{ item.date }}</div>
              </div>
              <div class="t-lk-promotions-completed-table__td t-lk-leads-table__top">
                <span v-if="item.status === leadStatusFront.WON" class="t-lk-leads-table__won">
                  {{ $root.staticText.lk.leadsStatus5 }}
                </span>
                <span v-else-if="item.status === leadStatusFront.FAILURE" class="t-lk-leads-table__failed">
                  {{ $root.staticText.lk.leadsStatus6 }}
                </span>
                <span v-else-if="item.status === leadStatusFront.EXPIRED" class="t-lk-leads-table__expired">
                  {{ $root.staticText.lk.leadsStatus7 }}
                </span>
              </div>
              <div class="t-lk-promotions-completed-table__td t-lk-leads-table__top">
                <span :class="['t-lk-leads-table__sum', { _rouble: item.sum }]">
                  {{ item.sum.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="footerTable" v-animation:bottom.delay class="t-lk-events__spent t-lk-leads-table__bottom">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.9997 25.6663C20.443 25.6663 25.6663 20.443 25.6663 13.9997C25.6663 7.55635 20.443 2.33301 13.9997 2.33301C7.55635 2.33301 2.33301 7.55635 2.33301 13.9997C2.33301 20.443 7.55635 25.6663 13.9997 25.6663Z"
            stroke="#00b0bd"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z"
            stroke="#00b0bd"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.0003 16.3337C15.289 16.3337 16.3337 15.289 16.3337 14.0003C16.3337 12.7117 15.289 11.667 14.0003 11.667C12.7117 11.667 11.667 12.7117 11.667 14.0003C11.667 15.289 12.7117 16.3337 14.0003 16.3337Z"
            stroke="#00b0bd"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>
          {{ footerTable }}
        </span>
      </div>
      <pagination-cmp
        v-animation:bottom.delay
        v-if="pagination && leadsCompleted.length > 0"
        :pagination="pagination"
        :name-current-page="'currentPage'"
        class="_lk"
      >
      </pagination-cmp>
    </div>
  </div>
</template>

<script>
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import lkSearch from '@components/lk/lk-search/lk-search.vue'
import filter from '@components/lk/lk-filter/lk-filter.vue'
import pagination from '@components/ui-components/pagination/pagination.vue'
import lkLeadsList from '@components/lk/lk-leads-list/lk-leads-list.vue'
import LeadTransferRulesNotice from '@modules/leads/ui/components/LeadTransferRulesNotice.vue'

import lkListIcon from './icons/list-icon.vue'
import lkTileIcon from './icons/tile-icon.vue'

import Vue from 'vue'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { LEAD_STATUS_FRONT } from '@pages/lk/leads/consts/lead.status'
import { observeNewAnimateBlocks } from '@shared/utils/animate//scroll.animate'
import { TRANSITION_DURATIONS } from '@shared/const/animation.const'

export default {
  name: 'lk-leads',
  components: {
    'banner-native-cmp': bannerNative,
    'lk-search-cmp': lkSearch,
    'filter-cmp': filter,
    'pagination-cmp': pagination,
    'lk-leads-list-cmp': lkLeadsList,
    // icons
    'lk-tile-icon': lkTileIcon,
    'lk-list-icon': lkListIcon,
    LeadTransferRulesNotice,
  },
  data() {
    return {
      leadsView: 'tile',
      leadStatusFront: LEAD_STATUS_FRONT,
      leadsCompletedTitle: [
        this.$root.staticText.lk.promotionsCompletedTable,
        this.$root.staticText.lk.promotionsCompletedTable2,
        this.$root.staticText.lk.promotionsCompletedTable3,
        this.$root.staticText.lk.leadsCompletedTable,
      ],
    }
  },
  computed: {
    ...mapState('lk/leads', {
      rating: state => state.rating,
      banner: state => state.banner,
      optionsRequest: state => state.optionsRequest,
      linkFaqBack: state => state.linkFaqBack,
      linkFaqMore: state => state.linkFaqMore,
      linkFaqCalc: state => state.linkFaqCalc,
      linkOffer: state => state.linkOffer,
      linkTerms: state => state.linkTerms,
      linkFaqLeads: state => state.linkFaqLeads,
      reasons: state => state.reasons,
      leadsCompleted: state => state.leadsCompleted,
      filter: state => state.filter,
      pagination: state => state.pagination,
      isFirst: state => state.isFirst,
      footerTable: state => state.footerTable,
      productionCalendar: state => state.productionCalendar,
      // TODO: когда покатится в мастер - раскоментить
      leadExpiredCount: state => state.leadExpiredCount,
      leads: state => state.leads,
      leadsFilter: state => state.leadsFilter,
    }),
    ...mapGetters('lk', {
      profile: 'profile',
    }),
  },
  methods: {
    ...mapActions('lk/leads', {
      lk_getLeadsPage: 'getLeadsPage',
      reuqestLeadsSecondStep: 'requestSecondStep',
    }),
    ...mapActions('modal', [
      'modalType_lkErrorOpen',
      'modalType_requestOpen',
      'modalType_missingDataOpen',
      'modalType_lkHowWorkWithLeads',
    ]),
    ...mapMutations('lk', ['setProfileItem']),
    async updateData() {
      await this.lk_getLeadsPage()
      this.$root.setDataAnimateFalse('.js-completed-leads ')
    },
    showHowWorkWithLeadsModal() {
      this.modalType_lkHowWorkWithLeads({ hiddenCloseBtn: true, overflowNone: true })
    },
    // модалка заполнить недостающие данные
    checkValidate() {
      switch (this.profile.validate) {
        case 1:
          break
        case 2:
          Vue.http
            .get(process.env.NODE_ENV === 'production' ? 'lk/partner/getForm' : 'lk/getForm.json')
            .then(response => response.json())
            .then(
              data => {
                if (data.success) {
                  this.modalType_missingDataOpen({
                    formInfo: data.form,
                    button: this.$root.staticText.forms.btn,
                    overflowNone: true,
                  })
                }
              },
              () => {}
            )
          break
        case 3:
          this.modalType_missingDataOpen({
            moderateText: this.$root.staticText.lk.moderateText,
            overflowNone: true,
          })
          break
        default:
          Vue.http
            .get(process.env.NODE_ENV === 'production' ? 'lk/partner/check' : 'lk/isAuth.json')
            .then(response => response.json())
            .then(
              data => {
                this.setProfileItem({
                  name: 'validate',
                  value: data.success ? 1 : 2,
                })
                this.checkValidate()
              },
              () => {}
            )
          break
      }
    },
    openError(data) {
      let text = this.$root.staticText.modal.errorText

      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }

      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: text,
        closeBthNone: true,
      })
    },
  },
  async mounted() {
    await this.lk_getLeadsPage(this.$route.query)
    this.checkValidate()
    this.$nextTick(() => {
      observeNewAnimateBlocks({ initialDelay: TRANSITION_DURATIONS.PAGE_TRANSFORM })
    })
  },
  async beforeRouteUpdate(to, _, next) {
    await this.lk_getLeadsPage(to.query)

    this.$root.setDataAnimateFalse('.js-completed-leads ')
    next()
    this.$nextTick(() => {
      observeNewAnimateBlocks()
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/pages/lk/leads/index.vue